var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTechAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9669_64731",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 16,
    cy: 16.3389,
    r: 16,
    fill: "#EBF3FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9669_64731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3054 13.3963C21.3054 16.1895 18.9764 18.4538 16.1035 18.4538C13.2305 18.4538 10.9015 16.1895 10.9015 13.3963C10.9015 10.6032 13.2305 8.33887 16.1035 8.33887C18.9764 8.33887 21.3054 10.6032 21.3054 13.3963Z",
    fill: "#C4CAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1034 21.4883C11.0758 21.4883 7 25.4508 7 30.3389V33.8389H25.2069V30.3389C25.2069 25.4508 21.1311 21.4883 16.1034 21.4883Z",
    fill: "#C4CAD4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTechAssign);
export default __webpack_public_path__ + "static/media/noTechAssign.19cbc4d39626e05881c9bee1a8531330.svg";
export { ForwardRef as ReactComponent };